import paymentusCheckoutDialog from "./paymentusCheckoutDialog.vue";
import paymentusFailureDialog from "./paymentusFailureDialog.vue";

export class PaymentusAdapter {
    init(data, driver) {
        this.promise = new Promise((_resolve, _reject) => {
            this.resolve = _resolve;
            this.reject = _reject;
        });

        this.timeout = null;
        this._driver = driver;

        this.authUrl = data.AuthUrl;
        this.token = data.AuthToken;
        this.postbackUrl = data.PostbackUrl;
        this.billingEmail = "";
        this.ePayType = "";
    }

    async updateEPaymentAuthToken(billingEmail, selectedEPaymentType) {
        this.billingEmail = billingEmail;
        this.ePayType = selectedEPaymentType;
        const result = await this._driver.PaymentusUpdateEPaymentAuthToken(this.billingEmail, this.ePayType);
        this.token = result.Data.authToken;
    }

    async checkout({ displayAmount, app }) {
        this.success = false;

        const dialogResult = await app.showDialog({
            customComponent: paymentusCheckoutDialog,
            customComponentOptions: {
                driver: this._driver,
                url: this.authUrl,
                token: this.token,
                epaytype: this.ePayType,
                displayamount: displayAmount,
                billingemail: this.billingEmail
            }
        });

        if (dialogResult.success) {
            app.setUnsavedChanges(false);
            app.unBlockUi();
            this._driver.showDialogAndNavigateToNext(
                dialogResult.resultData.ReceiptInfo,
                dialogResult.resultData.NavigateUrl
            );
            return this.promise;
        } else {
            if (dialogResult.resultData) {
                await app.showDialog({
                    customComponent: paymentusFailureDialog,
                    customComponentOptions: {
                        failureMessage: dialogResult.resultData.ChargeAdapterInfo,
                        referenceNumber: dialogResult.resultData.ReceiptInfo.ReceiptNumber
                    },
                    large: true,
                    buttons: [
                        {
                            text: "Close"
                        }
                    ]
                });
            }
            return { success: false };
        }
    }
}
